import React from 'react';
import { Col } from 'antd';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from './utils';
import next from '../assets/images/chevron-right.png';
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
import QueueAnim from 'rc-queue-anim';
import bg1 from '../assets/images/数字孪生行业应用-智慧矿山-01.jpg';
import bg2 from '../assets/images/数字孪生行业应用-智慧基建-01.jpg';
import bg5 from '../assets/images/数字孪生行业应用-智慧工厂-01.jpg';
import bg6 from '../assets/images/数字孪生行业应用-智慧物流-01.jpg';
const contentList = [
  {
    id: 1,
    content: '以数字孪生为核心、数据整合为基础，基于统一的数字空间，形成集可视化高度融合的生产指挥调度平台、高可靠安全监测及设备保障平台......',
    bg: bg1,
    link: ''
  },{
    id: 2,
    content: '对生产要素实现监测及采集，数据信息实时互联，助力管理人员对项目进度、人员、物料、质安、设备、生产的决策指挥，随时随地掌控项目......',
    bg: bg2,
    link: ''
  },{
    id: 3,
    content: '以数字孪生为核心、数据整合为基础，基于统一的数字空间，形成集可视化高度融合的生产指挥调度平台、高可靠安全监测及设备保障平台......',
    bg: bg1,
    link: ''
  },{
    id: 4,
    content: '以数字孪生为核心、数据整合为基础，基于统一的数字空间，形成集可视化高度融合的生产指挥调度平台、高可靠安全监测及设备保障平台......',
    bg: bg1,
    link: ''
  },{
    id: 5,
    content: '智慧工厂建设正处于关键期，需融合智能化和信息化技术，推动生产管理模式变革。通过工业物联网、大数据分析、数字化技术底座等手段......',
    bg: bg5,
    link: ''
  },{
    id: 6,
    content: '围绕“互联网+物流”概念，采用物联网、人工智能、大数据、云计算、智能硬件等先进技术与设备，构建物流智能化综合管理平台，并覆......',
    bg: bg6,
    link: ''
  },{
    id: 7,
    content: '以数字孪生为核心、数据整合为基础，基于统一的数字空间，形成集可视化高度融合的生产指挥调度平台、高可靠安全监测及设备保障平台......',
    bg: bg1,
    link: ''
  }
]

class Content5 extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      active: 1
    };
    this.isMobile = props.isMobile;
    this.scrollContainer = React.createRef();
    this.swiperRef = React.createRef();
  }
  
  getChildrenToRender = (data) =>
    data.map((item) => {
      return (
        <Col key={item.name} {...item}>
          <a {...item.children.wrapper}>
            <span {...item.children.img}>
              <img src={item.children.img.children} height="100%" alt="img" />
            </span>
            <p {...item.children.content}>{item.children.content.children}</p>
          </a>
        </Col>
      );
    });

  render() {
    const { ...props } = this.props;
    const { dataSource } = props;
    delete props.dataSource;
    delete props.isMobile;

    const navList = [
      {
        name: '智慧矿山',
        id: 1
      },
      {
        name: '智慧基建',
        id: 2
      },
      {
        name: '智慧农业',
        id: 3
      },
      {
        name: '智慧园区',
        id: 4
      },
      {
        name: '智慧工厂',
        id: 5
      },
      {
        name: '智慧物流',
        id: 6
      },
      {
        name: '智慧能源',
        id: 7
      }
    ];

    const navigationHandlers = {
      goToSlide: (index) => {
        if (this.swiperRef.current.swiper) {
          this.swiperRef.current.swiper.slideTo(index + 7);
        }
      },
      
      nextSlide: () => {
        if (this.swiperRef.current.swiper) {
          this.swiperRef.current.swiper.slideNext();
        }
      },
      
      prevSlide: () => {
        if (this.swiperRef.current.swiper) {
          this.swiperRef.current.swiper.slidePrev();
        }
      },
      
      getCurrentIndex: () => {
        if (this.swiperRef.current.swiper) {
          return this.swiperRef.current.swiper.realIndex;
        }
        return 0;
      }
    };

    const onSlideChange = () => {
      const currentIndex = navigationHandlers.getCurrentIndex();
      console.log('Current slide index:', currentIndex);
      this.setState({ active: currentIndex + 1 });
    };

    return (
      <div {...props} {...dataSource.wrapper}>
        <div {...dataSource.page}>
          <OverPack {...props} {...dataSource.OverPack}>
            <QueueAnim
              type="bottom"
              leaveReverse
              key="page"
              delay={[0, 100]}
            >
              <div key="title" {...dataSource.titleWrapper}>
                {dataSource.titleWrapper.children.map(getChildrenToRender)}
                <div className='content-nav-wrapper'>
                  <ul className='content-nav'>
                    {navList.map((item, index) => (
                      <li
                        key={item.id} className={this.state.active === index + 1 ? 'active' : ''}
                        onClick={() => navigationHandlers.goToSlide(index)}
                      >{item.name}</li>
                    ))}
                  </ul>
                  <div className='prev-next'>
                    <div 
                      onClick={() => navigationHandlers.prevSlide()}
                    >
                      <img src={next} className='prev' alt="prev" />
                    </div>
                    <div 
                      onClick={() => navigationHandlers.nextSlide()}
                    >
                      <img src={next} alt="next" />
                    </div>
                  </div>
                </div>
                <Swiper
                  ref={this.swiperRef}
                  spaceBetween={200}
                  slidesPerView={7}
                  loop={true}
                  onSlideChange={onSlideChange}
                  allowTouchMove={false}
                >
                  {contentList.map((item) => (
                    <SwiperSlide key={item.id}>
                      <div className='content-item'>
                        <img src={item.bg} alt="img" />
                        <div className='content-item-content'>
                          <p>{item.content}</p>
                          {/* eslint-disable-next-line */}
                          <a onClick={() => {
                            window.open(`/detail/${item.id}`, '_blank');
                          }}>查看详情&gt;&gt;</a>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </QueueAnim>
          </OverPack>
        </div>
      </div>
    );
  }
}

export default Content5;
